"use client";

import { cn } from "@/lib/utils";

export function OptionCard({
  label,
  selected,
  onClick,
}: {
  label: string;
  selected: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="option"
      className={cn(
        "flex w-full items-center justify-between rounded-xl border px-4 py-3.5 text-left text-sm font-medium transition",
        selected
          ? "border-brand bg-brand/15 text-ink"
          : "border-ink/15 bg-ink/[0.03] text-ink/90 hover:border-brand/50 hover:bg-ink/[0.05]"
      )}
    >
      <span>{label}</span>
      <span
        className={cn(
          "grid h-5 w-5 shrink-0 place-items-center rounded-full border",
          selected ? "border-brand bg-brand" : "border-ink/30"
        )}
      >
        {selected && <span className="h-2 w-2 rounded-full bg-cream" />}
      </span>
    </button>
  );
}
